import { defineMessages } from 'react-intl.macro';

export const commonMessages = defineMessages({
  formItemHelpLabel: {
    id: 'app.formItem.helpLabel',
    defaultMessage: 'Zobrazit nápovědu',
  },
  uploadBtn: {
    id: 'app.upload.btn',
    defaultMessage: 'Vyberte soubory',
  },
  uploadDropZone: {
    id: 'app.upload.dropZone',
    defaultMessage: 'Sem přetáhněte vaše soubory nebo',
  },
  uploadFail: {
    id: 'app.upload.fail',
    defaultMessage: 'Nahrání souboru/ů selhalo',
  },
  uploadMalwareDetected: {
    id: 'app.upload.malwareDetected',
    defaultMessage:
      'Soubor(y) nelze nahrát. Byly identifikovány antivirem jako nebezpečné. Prosím, nahrajte jiné soubory.',
  },
});
